import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'

@Singleton
export default abstract class DeviceShareApi {
    abstract code(deviceId: number): Promise<string>

    abstract qrcode(deviceId: number): Promise<string>
}

class DeviceShareApiImpl extends BaseApi implements DeviceShareApi {

    protected urlPrefix = 'device/share'

    code(deviceId: number): Promise<string> {
        return this.axios.get('code', {params: {deviceId: deviceId}})
    }

    async qrcode(deviceId: number): Promise<string> {
        const sharecode = await this.code(deviceId)
        return `https://iot.mulaitek.com?sharecode=${sharecode}`
    }
}

Container.bind(DeviceShareApi).to(DeviceShareApiImpl)
